<template>
    <!-- 材料题 -->
    <div class="itemConte CnConte">
        <h5>{{itmData.questionindex}}.（{{itmData.questiontypename+'，'+itmData.quesscore}}分）</h5>
        <p class="itemInfo" v-html="itmData.subject"></p>
        <div v-for="(item,index) in itmData.questionlist" :key="index">
            <!-- 单项选择 -->
            <SingleC :itmData="item"  v-if="item.questiontype === 1"/>
            <!-- 多项选择/不定项 -->
            <MultipleChoice :itmData="item" v-if="item.questiontype == 2 || item.questiontype == 3" />
            <!-- 判断题 -->
            <Judge :itmData="item" v-if="item.questiontype == 4" />

            <!-- 填空题 -->
            <Completion :itmData="item" v-if="item.questiontype == 5"  />
            <!-- 问答题 -->
            <QsAndAns :itmData="item" v-if="item.questiontype == 6" />
            <!-- 材料题 -->
            <MaterialQuestions :itmData="item" v-if="item.questiontype == 7" />
        </div>
    </div>
</template>
<script>
import MultipleChoice from './multipleChoice.vue'//多选
import Judge from './judge.vue'//判断题
import Completion from './completion.vue'//填空题
import MaterialQuestions from './materialQuestions.vue'//材料题
import SingleC from './singleC.vue'
import QsAndAns from './qsAndAns.vue'
export default {
    props: ['itmData'],
    components: {
        MultipleChoice,
        Judge,
        Completion,
        MaterialQuestions,
        SingleC,
        QsAndAns
    }
}
</script>
<style lang="scss" scoped>

</style>